/**
 * `/logout` — a real route rendering a signed-out page.
 *
 * Required by the front-channel logout URL configured on both SPA
 * registrations (ITRequest.md). Pointing front-channel logout at the bare
 * origin sends the user back into the app, which immediately tries to sign
 * them in again — a loop that looks like logout is broken.
 */
export function Logout(): React.ReactElement {
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="max-w-sm space-y-4 text-center">
        <h1 className="text-lg font-semibold">You are signed out</h1>
        <p className="text-sm text-muted-foreground">
          Close this tab, or sign in again to return to the funnel.
        </p>
        <a className="text-sm underline underline-offset-4" href="/" rel="noopener noreferrer">
          Sign in again
        </a>
      </div>
    </div>
  );
}
